export default "__VITE_ASSET__a9nYpPuf__"